import { replace } from 'react-router-redux';
import { openGlobalModal } from 'actions/modal';
import { getCouponList } from 'actions/coupon';

export default store => ({
	path: 'coupon',
	indexRoute: {
		getComponent: (nextState, cb) =>
			require.ensure(
				[],
				require => {
					const component = require('./container').default;
					cb(null, component);
				},
				'Coupon',
			),
		onEnter: () => {
			const { auth: { token: { accessToken } } } = store.getState();
			const { members: { emailVerify } } = store.getState();
			if (accessToken === '') {
				store.dispatch(replace('/login'));
			} else {
				if (emailVerify === 0) {
					store.dispatch(openGlobalModal('verifyEmailNotyet'));
				}
				store.dispatch(getCouponList());
			}
		},
	},
});



// WEBPACK FOOTER //
// ./src/routes/Coupon/index.js